"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IIIFImageLogo = void 0;
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const axios_1 = __importDefault(require("axios"));
const IIIFImageLogo = (props) => {
    const [logoUrl, setLogoUrl] = (0, react_1.useState)("");
    (0, react_1.useEffect)(() => {
        axios_1.default.get(props.imageurl + "/info.json").then((d) => {
            const logo = d.data.logo["@id"];
            setLogoUrl(logo);
        }).catch((error) => {
            //console.log("no logo found")
            setLogoUrl("");
        });
    }, [props.imageurl]);
    return (react_1.default.createElement(react_1.default.Fragment, null, logoUrl && react_1.default.createElement("img", { src: logoUrl, style: { margin: props.margin, height: props.height } })));
};
exports.IIIFImageLogo = IIIFImageLogo;
IIIFImageLogo.defaultProps = {
    height: "20px",
    margin: "5px",
    imageurl: "https://api.digitale-sammlungen.de/iiif/image/v2/bsb00103424_00005"
};
IIIFImageLogo.propTypes = {
    /**
    * imageurl (without iiif parameters) for which logo will be requested
    **/
    imageurl: prop_types_1.default.string.isRequired,
    margin: prop_types_1.default.string,
    height: prop_types_1.default.string
};
//# sourceMappingURL=iiif-image-logo.js.map